<div class="fizz-grid-center">
  <div
    class="fizz-card card-wrapper fizz-bordered fizz-elevation-1 fizz-text-center fizz-inset-square-24"
    style="margin-top: 24px;"
  >
    <p class="fizz-text-strong">We had an error loading this deal - please refresh.</p>
  </div>
</div>
